import { t } from "@/lib";
import { cn } from "@ui/lib/utils";

interface BadgeProps {
  dictionary: any;
}

export const TypeBadge = ({ type, dictionary }: { type: string } & BadgeProps) => {
  return (
    <div className="rounded text-gray-800 m-1 text-sm text-center">
      {t(dictionary, `tablatures.types.${type}`, { defaultValue: type })}
    </div>
  );
};

export const KeyBadge = ({ value, dictionary }: { value: string } & BadgeProps) => {
  return (
    <div className="rounded text-gray-800 m-1 text-sm text-center">
      {t(dictionary, `tablatures.keys.${value}`, { defaultValue: value })}
    </div>
  );
};

export const CategoryBadge = ({ category, dictionary }: { category: string } & BadgeProps) => {
  return (
    <div className="rounded text-gray-800 m-1 text-sm text-center">
      {t(dictionary, `tablatures.categories.${category}`, { defaultValue: category })}
    </div>
  );
};

export const DifficultyBadge = ({ difficulty, dictionary }: { difficulty: string } & BadgeProps) => {
  return (
    <div
      className={cn(
        'rounded-sm text-white px-2 py-1 text-xs text-center w-22 flex items-center justify-center',
        {
          'bg-green-600': difficulty === 'easy',
          'bg-yellow-600': difficulty === 'medium',
          'bg-red-600': difficulty === 'hard',
          'bg-purple-600': difficulty === 'expert',
        }
      )}
    >
      {t(dictionary, `tablatures.difficulties.${difficulty}`)}
    </div>
  );
};

export const ViewsBadge = ({ views, dictionary }: { views: number } & BadgeProps) => {
  return (
    <div className="rounded text-gray-800 px-2 py-1 m-1 text-center text-xs">
      {t(dictionary, 'common.views', { count: views })}
    </div>
  );
};

export const StatusBadge = ({ status, dictionary }: { status: string } & BadgeProps) => {
  return (
    <div
      className={cn(
        'rounded-sm text-white px-2 py-1 text-xs text-center w-22 flex items-center justify-center', {
        'bg-green-600 text-white': status === 'public',
        'border border-gray-500 text-gray-500 bg-transparent': status === 'submitted',
        'bg-red-600 text-white': status === 'deleted',
        'bg-gray-600 text-white': status === 'private',
      })}
    >
      {t(dictionary, `tablatures.status.${status}`, { defaultValue: status })}
    </div>
  );
};

export const RoleBadge = ({ role, dictionary }: { role: number } & BadgeProps) => {
  return (
    <div
      className={cn('rounded text-white px-2 py-1 text-xs text-center inline-block', {
        'bg-purple-500': role === 0,
        'bg-yellow-500': role === 1,
        'bg-green-500': role === 2,
        'bg-cyan-500': role === 3,
        'bg-gray-600': role === 4,
        'bg-red-500': role === 5,
      })}
    >
      {t(dictionary, `roles.role_${role}`, { defaultValue: `Role ${role}` })}
    </div>
  );
};
